import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { TranslationService } from './service/translation-service.service';

@Component({
  standalone: true,
  template: '',
})
export class WikiRedirectComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly translation = inject(TranslationService);

  constructor() {
    const path = this.route.snapshot.url.map(({ path }) => path).join('/');
    const localePath = path || `${this.translation.language}/home`;
    window.location.replace(`${environment.wikiBaseUrl}/${localePath}`);
  }
}
